import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../../environment/environment';
import { DataSourceFunction, ComponentDataSourceService } from '../../component-data-source.service';

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export interface EventExtraSettingsDTO {
  category: string | null;
  smoke_development: boolean;
  cleaning: boolean;
  cash_list_required: boolean;
  certificates_created: boolean;
  cash_list_packed_date: string | null;
}

export const event_extra = (service: ComponentDataSourceService): DataSourceFunction => ({
  name: 'event_extra',
  description: 'Get event extra settings from data jsonb',
  execute: (): Observable<EventExtraSettingsDTO> => {
    const router = service.injector.get(Router);
    const urlWithoutQuery = (router.url || '').split('?')[0];
    const eventGuid = urlWithoutQuery
      .split('/')
      .find((segment: string) => UUID_REGEX.test(segment));

    if (!eventGuid) {
      throw new Error('No valid event GUID found in URL');
    }

    return service.http.get<EventExtraSettingsDTO>(
      `${environment.apiUrl}/events/${eventGuid}/extra-settings`
    );
  }
});
